module.exports = __webpack_public_path__ + "img/home_map.e5a08c94.png";